(() => {
  let pending = false;
  const update = () => {
    pending = false;
    document.querySelectorAll('product-info[data-az-compact-controls].az-product-layout-ready').forEach(root => {
      const info = root.querySelector('.product__info-container');
      if (!info) return;
      const delivery = info.querySelector('.az-entrega');
      if (delivery && delivery.style.marginTop !== '0px') delivery.style.setProperty('margin-top', '0px', 'important');
      const guide = info.querySelector('.az-size-guide-opener');
      const variants = info.querySelector('variant-selects:not([style*="display: none"]):not([style*="display:none"])');
      const inlineSizes = !!variants && !root.classList.contains('az-product-sheet-ready')
        && !!variants.querySelector('fieldset[data-az-size-option] label');
      let row = info.querySelector(':scope > .az-pdp-options-row');
      if (!guide && !inlineSizes) {
        if (row) row.remove();
        info.style.removeProperty('--az-color-options-gap');
        return;
      }
      const colorGap = guide && !inlineSizes ? '2px' : '8px';
      if (info.style.getPropertyValue('--az-color-options-gap') !== colorGap) {
        info.style.setProperty('--az-color-options-gap', colorGap);
      }
      if (!row) {
        row = document.createElement('div');
        row.className = 'az-pdp-options-row';
        info.insertBefore(row, guide?.parentElement === info ? guide : variants?.parentElement === info ? variants : null);
      }
      row.classList.toggle('az-has-inline-sizes', inlineSizes);
      if (inlineSizes && variants.parentElement !== row) row.prepend(variants);
      if (!inlineSizes && variants?.parentElement === row) info.insertBefore(variants, row);
      if (guide && guide.parentElement !== row) row.append(guide);
    });
  };
  const schedule = () => {
    if (!pending) {
      pending = true;
      requestAnimationFrame(update);
    }
  };
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('DOMContentLoaded', schedule);
  schedule();
})();

